<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">查看合同 - {{ data && data.memberName ? data.memberName : '' }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <div class="p_container">
        <div v-for="(photo, index) in photoes" :key="index" clsss="p_wrapper" style="text-align: center; font-size: 9pt;">
          <div class="image_container" :class="{no_image: photo && photo.full === ''}">
            <vue-viewer v-if="photo && photo.full" :thumb="photo.thumb" :full="photo.full" />
            <span v-else>尚未上传</span>
          </div>
          <div>分页照{{ index + 1 }}</div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button
        size="small"
        icon="ios-checkmark-circle-outline"
        @click="closeModal"
      >
        关闭
      </Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'ContractView',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 500
    },
    data: {
      type: Object,
      default() { return {} }
    }
  },
  data() {
    return {
      loadingStatus: false
    }
  },
  computed: {
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    photoes() {
      const photoes = []
      const extension = this.$config.imageFileExt
      const storageHost = this.$config.storageHost
      if (this.data) {
        const photoList = this.data.contract.split(',')
        for (const photo of photoList) {
          if (photo) {
            const path = storageHost + '/photo/' + photo + '/' + photo
            photoes.push({ thumb: path + '_24x24' + extension, full: path + extension })
          } else {
            photoes.push({ thumb: '', full: '' })
          }
        }
      }
      return photoes
    },
    title() {
      return '车辆图片 - ' + this.vehicleNumber
    }
  },
  methods: {
    closeModal: function() {
      this.$emit('on-close', false)
    }
  }
}
</script>

<style lang="less">
    .p_container {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .image_container {
        height: 48px;
        width: 48px;
        border: 1px solid #ccc;
        padding: 4px;
        margin-bottom: 5px;
        cursor: zoom-in;
    }
    .no_image {
        align-items: center;
        display: flex;
        justify-content: center;
    }
    .p_wrapper {
        text-align: center;
    }
</style>
